var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPandoraColorLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 50,
    viewBox: "0 0 107 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pandora"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pandora-color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 24C65 20.1405 68.1405 17 72 17C75.8595 17 79 20.1027 79 24C79 27.8595 75.8595 31 72 31C68.1405 31 65 27.8595 65 24ZM76.2 24C76.2 21.6919 74.3081 19.8 72 19.8C69.6919 19.8 67.8 21.6541 67.8 24C67.8 26.3081 69.6919 28.2 72 28.2C74.3081 28.2 76.2 26.3081 76.2 24Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.427 18.5892V17.4541H30V30.5459H27.427V29.4108C26.2162 30.3946 24.6649 31 23 31C19.1405 31 16 27.8595 16 24C16 20.1405 19.1405 17 23 17C24.6649 17 26.2162 17.6054 27.427 18.5892ZM18.8 24.0378C18.8 26.4216 20.7297 28.3892 23.1514 28.3892C25.5351 28.3892 27.5027 26.4216 27.5027 24.0378C27.5027 21.6541 25.573 19.6865 23.1514 19.6865C20.7676 19.6865 18.8 21.6162 18.8 24.0378Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.427 18.5892V17.4541H103V30.5459H100.427V29.4108C99.2162 30.3946 97.6649 31 96 31C92.1405 31 89 27.8595 89 24C89 20.1405 92.1405 17 96 17C97.6649 17 99.2162 17.6054 100.427 18.5892ZM91.8378 24.0378C91.8378 26.4216 93.7676 28.3892 96.1892 28.3892C98.573 28.3892 100.541 26.4216 100.541 24.0378C100.541 21.6541 98.6108 19.6865 96.1892 19.6865C93.8054 19.6865 91.8378 21.6162 91.8378 24.0378Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M83.6839 18.2912C82.2332 19.2688 81 21.0285 81 24.1568V31H83.6839V24.1568C83.6839 19.6599 88 19.8945 88 19.8945V17.0008C87.9637 17.0008 85.6425 16.9226 83.6839 18.2912Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M43.2 18.4429C42.027 17.546 40.5892 17 39 17C37.4108 17 35.973 17.546 34.8 18.4429C33.0973 19.7688 32 21.8747 32 24.2145V31H34.8V29.9861V24.2145C34.8 21.8357 36.6919 19.8858 39 19.8858C41.3081 19.8858 43.2 21.8357 43.2 24.2145V29.9861V31H46V24.2145C46 21.8357 44.9027 19.7298 43.2 18.4429Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.427 15.3049C59.427 14.5757 59.9946 14 60.7135 14H62V15.3049V31.5394H59.427V30.3881C58.2162 31.3859 56.6649 32 55 32C51.1405 32 48 28.8145 48 24.8998C48 20.9851 51.1405 17.7996 55 17.7996C56.6649 17.7996 58.2162 18.4136 59.427 19.4115V15.3049ZM50.8 24.9382C50.8 27.3561 52.7297 29.3518 55.1514 29.3518C57.573 29.3518 59.5405 27.3561 59.5027 24.9382C59.5027 22.5203 57.573 20.5245 55.1514 20.5245C52.7676 20.5245 50.8 22.4819 50.8 24.9382Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57297 18.6085C3.78378 17.6128 5.33513 17 7 17C10.8973 17 14 20.1404 14 24.0851C14 27.9915 10.8973 31.1702 7 31.1702C5.33513 31.1702 3.78378 30.5574 2.57297 29.5617V33.6979C2.57297 34.4255 2.00541 35 1.28649 35H0V33.6979V17.4596H2.57297V18.6085ZM2.4973 24.0851C2.4973 26.4979 4.42703 28.4894 6.84865 28.4894C9.27027 28.4894 11.2 26.4979 11.2 24.0851C11.2 21.6723 9.23243 19.6809 6.84865 19.6809C4.46486 19.6809 2.4973 21.634 2.4973 24.0851Z",
    fill: "#00A0EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104 16.5C104 17.3382 104.662 18 105.5 18C106.338 18 107 17.3382 107 16.5C107 15.6618 106.338 15 105.5 15C104.662 15 104 15.6618 104 16.5ZM104.176 16.5C104.176 15.75 104.75 15.1765 105.5 15.1765C106.206 15.1765 106.824 15.75 106.824 16.5C106.824 17.2059 106.25 17.8235 105.5 17.8235C104.75 17.8235 104.176 17.2059 104.176 16.5ZM105.897 17.3824L105.456 16.7206H105.147V17.3824H104.926V15.6618H105.632C105.941 15.6618 106.162 15.8824 106.162 16.1912C106.162 16.5882 105.809 16.7206 105.721 16.7206L106.162 17.4265H105.897V17.3824ZM105.147 15.8382H105.632C105.765 15.8382 105.941 15.9706 105.941 16.1912C105.941 16.3676 105.765 16.5 105.632 16.5H105.147V15.8382Z",
    fill: "#00A0EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandoraColorLight);
export default __webpack_public_path__ + "static/media/pandora-color-light.67928beb1bb0a25a06b91acbbbd5bcb6.svg";
export { ForwardRef as ReactComponent };